/**
 * Header fields shared by the collection hexagon and DSP report adapters.
 * The model path reads these from `project`/`pickedTask`; a collection has the
 * same project in context and its own detection objects in place of the task.
 *
 * @module collectionReportHeader
 */

import { getGsdInCm } from '@utils/gsd';

/**
 * @param {Object} params
 * @param {Object} [params.project] - current project (area in m², created_at, gsd)
 * @param {Array<{label: string}>} [params.objects] - the collection's detection objects
 * @returns {{ projectArea: string|null, projectCreated: string|null, gsd: number|null,
 *   modelClasses: string }}
 */
export const collectionReportHeader = ({ project, objects } = {}) => ({
	// Project area is stored in m²; the report shows hectares.
	projectArea: project?.area > 0 ? (project.area / 10000).toFixed(2) : null,
	projectCreated: project?.created_at ? new Date(project.created_at).toLocaleDateString() : null,
	// GSD is stored in m/px; the report shows cm/px.
	gsd: getGsdInCm(project),
	modelClasses:
		(objects ?? [])
			.map(o => o?.label)
			.filter(Boolean)
			.join(', ') || 'N/A',
});

export default collectionReportHeader;
